export default {
    id: "54b8601e-124a-453b-983a-7ce8e4738de3",
    icon: "mdi-tab",
    name: "tabs",
    title: "Tabs",
    description: "A block tabs",
}